module.exports = __webpack_public_path__ + "static/media/republic-of-the-congo.0b94b223.svg";